module.exports = __webpack_public_path__ + "static/media/achiote.588061ae.png";